export const spareParts = [
  // --- قطع غيار Marking ---
  {
    id: 1,
    name: "Cable Scanner",
    name_ar: "ماسح الكابلات",
    image: "/spare-parts/cable-scanner.png",
    code: "MRK-001",
    category: "Marking",
    sizes: [],
    description: ""
  },
  {
    id: 2,
    name: "LV7 JCZ control card original",
    name_ar: "كارت تحكم JCZ LV7 الأصلي",
    image: "/spare-parts/jcz-card.png",
    code: "MRK-002",
    category: "Marking",
    sizes: [],
    description: ""
  },
  {
    id: 3,
    name: "Raycus Source QB 30W",
    name_ar: "مصدر ليزر Raycus QB بقدرة 30 واط",
    image: "/spare-parts/raycus-30w.png",
    code: "MRK-003",
    category: "Marking",
    sizes: [],
    description: ""
  },
  {
    id: 4,
    name: "Raycus Source QB 50W",
    name_ar: "مصدر ليزر Raycus QB بقدرة 50 واط",
    image: "/spare-parts/raycus-50w.png",
    code: "MRK-004",
    category: "Marking",
    sizes: [],
    description: ""
  },
  {
    id: 5,
    name: "Raycus Source QS 30W",
    name_ar: "مصدر ليزر Raycus QS بقدرة 30 واط",
    image: "/spare-parts/raycus-qs30w.png",
    code: "MRK-005",
    category: "Marking",
    sizes: [],
    description: ""
  },
  {
    id: 6,
    name: "Red Point With Holder",
    name_ar: "مؤشر ليزر أحمر مع الحامل",
    image: "/spare-parts/red-point.png",
    code: "MRK-006",
    category: "Marking",
    sizes: [],
    description: ""
  },

  // --- قطع غيار Press Brake ---
  {
    id: 7,
    name: "30ºPunch Size:130*26*835",
    name_ar: "بنش 30° مقاس 130×26×835",
    image: "/spare-parts/punch-30.png",
    code: "PRB-001",
    category: "  Press Brake",
    sizes: ["Standard", "Segment"],
    description: ""
  },
  {
    id: 8,
    name: "Die V16 Size:80*60*835",
    name_ar: "قالب V16 مقاس 80×60×835",
    image: "/spare-parts/die-v16.png",
    code: "PRB-002",
    category: "  Press Brake",
    sizes: ["Standard", "Segment"],
    description: ""
  },
  {
    id: 9,
    name: "Goosenack 60ºPunch Size:115*36*835mm",
    name_ar: "بنش عنق الإوزة 60° مقاس 115×36×835 مم",
    image: "/spare-parts/gooseneck-60.png",
    code: "PRB-003",
    category: "  Press Brake",
    sizes: ["Standard", "Segment"],
    description: ""
  },
  {
    id: 10,
    name: "Hemming Die Spring L835",
    name_ar: "قالب هيمينج زنبركي بطول 835 مم",
    image: "/spare-parts/hemming-die.png",
    code: "PRB-004",
    category: "  Press Brake",
    sizes: [],
    description: ""
  },

  // --- قطع غيار CNC Router ---
  {
    id: 11,
    name: "5M 19Din 20T Gear",
    name_ar: "ترس 5M مقاس 19Din 20T",
    image: "/spare-parts/gear-5m.png",
    code: "CNC-001",
    category: "  cnc router",
    sizes: [],
    description: ""
  },
  {
    id: 12,
    name: "BEST inverter 7.5KW",
    name_ar: "إنفرتر BEST بقدرة 7.5 كيلوواط",
    image: "/spare-parts/best-inverter.png",
    code: "CNC-002",
    category: "  cnc router",
    sizes: ["220V", "380V"],
    description: ""
  },
  {
    id: 13,
    name: "Belt 5M 550",
    name_ar: "سير توقيت 5M 550",
    image: "/spare-parts/Belt 5M 550.jfif",
    code: "CNC-003",
    category: "  cnc router",
    sizes: [],
    description: ""
  },
  {
    id: 14,
    name: "DSP Richauto A11",
    name_ar: "وحدة تحكم DSP RichAuto A11",
    image: "/spare-parts/DSP Richauto A11.jfif",
    code: "CNC-004",
    category: "  cnc router",
    sizes: [],
    description: ""
  },
  {
    id: 15,
    name: "Planetary reducer 5:1 PL80-5/60-14/M5 1:5",
    name_ar: "مخفض سرعة كوكبي PL80 بنسبة 5:1",
    image: "/spare-parts/Planetary reducer.jfif",
    code: "CNC-005",
    category: "  cnc router",
    sizes: [],
    description: ""
  },
  {
    id: 16,
    name: "Proximity sensor 24V NPN",
    name_ar: "حساس اقتراب 24V NPN",
    image: "/spare-parts/Proximity sensor 24V NPN.jfif",
    code: "CNC-006",
    category: "  cnc router",
    sizes: [],
    description: ""
  },
  {
    id: 17,
    name: "Stepper Driver DMA860",
    name_ar: "درايفر محرك خطوي DMA860",
    image: "/spare-parts/Stepper Driver DMA860.jfif",
    code: "CNC-007",
    category: "  cnc router",
    sizes: [],
    description: ""
  },
  {
    id: 18,
    name: "Stepper Motor NEMA 34 8N.M",
    name_ar: "محرك خطوي NEMA 34 بعزم 8 نيوتن.متر",
    image: "/spare-parts/Stepper Motor NEMA.jfif",
    code: "CNC-008",
    category: " cnc router",
    sizes: [],
    description: ""
  },
  {
    id: 19,
    name: "Timing Pulley 5M - 18 - 13",
    name_ar: "بكرة توقيت 5M - 18 - 13",
    image: "/spare-parts/Timing Pulley 5M.jfif",
    code: "CNC-009",
    category: "  cnc router",
    sizes: [],
    description: ""
  },

  // --- قطع غيار Fiber Laser Cutting ---
  {
    id: 20,
    name: "BM111 Raytools",
    name_ar: "رأس ليزر BM111 من Raytools",
    image: "/spare-parts/BM111 Raytools.jfif",
    code: "FBR-001",
    category: "  fiber laser cutting",
    sizes: [],
    description: ""
  },
  {
    id: 21,
    name: "Backward Dust Cover",
    name_ar: "غطاء حماية خلفي من الغبار",
    image: "/spare-parts/Backward Dust Cover.jfif",
    code: "FBR-002",
    category: "  fiber laser cutting",
    sizes: [],
    description: ""
  },
  {
    id: 22,
    name: "COTTON SWAB MEDIUM",
    name_ar: "عود تنظيف متوسط",
    image: "/spare-parts/COTTON SWAB MEDIUM.jfif",
    code: "FBR-003",
    category: "  fiber laser cutting",
    sizes: [],
    description: ""
  },
  {
    id: 23,
    name: "Ceramic",
    name_ar: "سيراميك",
    image: "/spare-parts/Ceramic.jfif",
    code: "FBR-004",
    category: "  fiber laser cutting",
    sizes: ["D28", "D32"],
    description: ""
  },
  {
    id: 24,
    name: "Ceramic Ring",
    name_ar: "حلقة سيراميك",
    image: "/spare-parts/Ceramic Ring.jfif",
    code: "FBR-005",
    category: "  fiber laser cutting",
    sizes: ["D32", "WSX-WTC08"],
    description: ""
  },
  {
    id: 25,
    name: "Collimation Focus Lens",
    name_ar: "عدسة كوليميشن",
    image: "/spare-parts/Collimation Focus Lens.jfif",
    code: "FBR-006",
    category: "  fiber laser cutting",
    sizes: ["D30 F100", "D37 F100", "D38.1 F100"],
    description: ""
  },
  {
    id: 26,
    name: "Focus Lens",
    name_ar: "عدسة تركيز",
    image: "/spare-parts/Focus Lens.jfif",
    code: "FBR-007",
    category: "  fiber laser cutting",
    sizes: ["D30 F125", "D37 F150", "D37 F200", "D38.1 F200"],
    description: ""
  },
  {
    id: 27,
    name: "Fiber Laser Nozzle Single Chrome",
    name_ar: "فونية ليزر فايبر مفردة كروم",
    image: "/spare-parts/Fiber Laser Nozzle Single Chrome.jfif",
    code: "FBR-008",
    category: "  fiber laser cutting",
    sizes: ["1.0mm", "1.2mm", "1.4mm", "1.5mm", "2.0mm", "2.5mm", "3.0mm", "3.5mm", "4.0mm", "4.5mm", "5.0mm"],
    description: ""
  },
  {
    id: 28,
    name: "Fiber Laser Nozzle Double Chrome",
    name_ar: "فونية ليزر فايبر مزدوجة كروم",
    image: "/spare-parts/Fiber Laser Nozzle Double Chrome.jfif",
    code: "FBR-009",
    category: "  fiber laser cutting",
    sizes: ["1.0mm", "1.2mm", "1.4mm", "1.5mm", "2.0mm", "2.5mm", "3.0mm", "3.5mm", "4.0mm", "4.5mm", "5.0mm"],
    description: ""
  },
  {
    id: 29,
    name: "Fiber Laser Nozzle CP Raytools Single",
    name_ar: "فونية ليزر CP Raytools مفردة",
    image: "/spare-parts/Fiber Laser Nozzle CP Raytools Single.jfif",
    code: "FBR-010",
    category: "  fiber laser cutting",
    sizes: ["1.2mm", "1.4mm", "1.5mm", "2.0mm", "2.5mm", "3.0mm", "3.5mm", "4.0mm"],
    description: ""
  },
  {
    id: 30,
    name: "Fiber Laser Nozzle CP Raytools Double",
    name_ar: "فونية ليزر CP Raytools مزدوجة",
    image: "/spare-parts/Fiber Laser Nozzle CP Raytools Double.jfif",
    code: "FBR-011",
    category: "  fiber laser cutting",
    sizes: ["1.2mm", "1.4mm", "1.5mm", "2.0mm", "2.5mm", "3.0mm", "3.5mm", "4.0mm", "4.5mm", "5.0mm"],
    description: ""
  },
  {
    id: 31,
    name: "Protective Lens",
    name_ar: "عدسة حماية",
    image: "/spare-parts/Protective Lens.jfif",
    code: "FBR-012",
    category: "  fiber laser cutting",
    sizes: ["22.35X4", "24.9X1.5", "25.4×4", "27.9X4.1", "34×5 8KW", "37X7 Raytools", "37×7", "38.1X1.6"],
    description: ""
  },
  {
    id: 32,
    name: "QBH BWT",
    name_ar: "موصل QBH BWT",
    image: "/spare-parts/QBH BWT.jfif",
    code: "FBR-013",
    category: "  fiber laser cutting",
    sizes: ["Standard", "Original 3Kw"],
    description: ""
  },
  {
    id: 33,
    name: "Hanli Chiller 3000",
    name_ar: "مبرد Hanli 3000",
    image: "/spare-parts/Hanli Chiller 3000.jfif",
    code: "FBR-014",
    category: "  fiber laser cutting",
    sizes: [],
    description: ""
  },
  {
    id: 34,
    name: "Non Return Valve 3/8 Female",
    name_ar: "صمام عدم رجوع 3/8 أنثى",
    image: "/spare-parts/1.jfif",
    code: "FBR-015",
    category: "  fiber laser cutting",
    sizes: [],
    description: ""
  },
  {
    id: 35,
    name: "Raycus Laser Source 1500W 60 HZ",
    name_ar: "مصدر ليزر Raycus بقدرة 1500 واط",
    image: "/spare-parts/Raycus Laser Source 1500W 60 HZ.jfif",
    code: "FBR-016",
    category: "  fiber laser cutting",
    sizes: [],
    description: ""
  },

  // --- قطع غيار Plasma ---
  {
    id: 36,
    name: "Electrode 65A/85A/105A",
    name_ar: "إلكترود بلازما 65/85/105 أمبير",
    image: "/spare-parts/2.jfif",
    code: "PLS-001",
    category: "  plasma",
    sizes: [],
    description: ""
  },
  {
    id: 37,
    name: "Nozzle 65A/85A/105A",
    name_ar: "فونية بلازما 65/85/105 أمبير",
    image: "/spare-parts/3.jfif",
    code: "PLS-002",
    category: "  plasma",
    sizes: [],
    description: ""
  },
  {
    id: 38,
    name: "Powermax105 Plasma Torch 7.6m",
    name_ar: "شعلة بلازما Powermax 105 بطول 7.6 متر",
    image: "/spare-parts/Powermax105 Plasma Torch 7.6m.jfif",
    code: "PLS-003",
    category: "  plasma",
    sizes: [],
    description: ""
  },
  {
    id: 39,
    name: "Retaining Cap 65A/85A/105A",
    name_ar: "غطاء تثبيت 65/85/105 أمبير",
    image: "/spare-parts/Retaining Cap 65A/85A/105A.jfif",
    code: "PLS-004",
    category: "  plasma",
    sizes: [],
    description: ""
  },
  {
    id: 40,
    name: "Set Nozzle With Electrode",
    name_ar: "طقم فونية مع إلكترود",
    image: "/spare-parts/Set Nozzle With Electrode.jfif",
    code: "PLS-005",
    category: "  plasma",
    sizes: ["1.1", "1.3", "1.5", "1.7"],
    description: ""
  },
  {
    id: 41,
    name: "Shield Cap 65A/85A/105A",
    name_ar: "غطاء حماية 65/85/105 أمبير",
    image: "/spare-parts/Shield Cap.jfif",
    code: "PLS-006",
    category: "  plasma",
    sizes: [],
    description: ""
  },
  {
    id: 42,
    name: "Swirl Ring 65A/85A/105A",
    name_ar: "حلقة دوامية 65/85/105 أمبير",
    image: "/spare-parts/Swirl Ring.jfif",
    code: "PLS-007",
    category: "  plasma",
    sizes: [],
    description: ""
  },
  {
    id: 43,
    name: "تورش 105A",
    name_ar: "شعلة بلازما 105 أمبير",
    image: "/spare-parts/تورش.jfif",
    code: "PLS-008",
    category: "  plasma",
    sizes: [],
    description: ""
  },
  {
    id: 44,
    name: "موتور محور Z",
    name_ar: "محرك المحور Z",
    image: "/spare-parts/Z.jfif",
    code: "PLS-009",
    category: "  plasma",
    sizes: [],
    description: ""
  },

  // --- قطع غيار كمبروسور ---
  {
    id: 45,
    name: "فلتر زيت",
    name_ar: "فلتر زيت",
    image: "/spare-parts/فلتر.jfif",
    code: "CMP-001",
    category: "  كمبروسور",
    sizes: ["S", "L", "oil separator element 1622087100"],
    description: ""
  },
  {
    id: 46,
    name: "فلتر هواء",
    name_ar: "فلتر هواء",
    image: "/spare-parts/هواء.jfif",
    code: "CMP-002",
    category: "  كمبروسور",
    sizes: [],
    description: ""
  },

  // --- قطع غيار ماكينة لحام YAG ---
  {
    id: 47,
    name: "Lamp 8x125",
    name_ar: "لمبة YAG مقاس 8×125",
    image: "/spare-parts/لمبة.jfif",
    code: "YAG-001",
    category: "  ماكينة لحام YAG",
    sizes: [],
    description: ""
  },
  {
    id: 48,
    name: "Lens 20x5",
    name_ar: "عدسة YAG مقاس 20×5",
    image: "/spare-parts/Lens.jfif",
    code: "YAG-002",
    category: "  ماكينة لحام YAG",
    sizes: ["T100%", "T5%"],
    description: ""
  }
];